import React, { useState, useEffect } from 'react';
import './styles.css';

function FormFileUpload({ 
  label, 
  onUpload, 
  onDelete, 
  files = [], 
  multiple = false, 
  accept = '*', 
  required = false,
  token,
  previewUrls = []
}) {
  const [localPreviewUrls, setLocalPreviewUrls] = useState(previewUrls);

  useEffect(() => {
    setLocalPreviewUrls(previewUrls);
  }, [previewUrls]);

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    
    if (selectedFiles.length > 0) {
      const processedFiles = [];
      const newPreviewUrls = [];
      
      for (const file of selectedFiles) {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const previewUrl = reader.result;
            newPreviewUrls.push(previewUrl);
            setLocalPreviewUrls(prev => [...prev, previewUrl]);
          };
          reader.readAsDataURL(file);
          processedFiles.push(file);
        } else {
          processedFiles.push(file);
        }
      }
      
      onUpload(processedFiles);
    }
  };

  const handleDelete = (index) => {
    setLocalPreviewUrls(prevUrls => prevUrls.filter((_, i) => i !== index));
    onDelete(index);
  };

  return (
    <div className="form-file-upload">
      <label className="file-upload-label">
        {label} {required && <span className="required-mark">*</span>}
      </label>
      
      <div className="file-upload-input-container">
        <input
          type="file"
          onChange={handleFileChange}
          className="file-upload-input"
          multiple={multiple}
          accept={accept}
        />
        <div className="file-upload-button">
          選擇文件
        </div>
      </div>
      
      {files.length > 0 && (
        <div className="file-preview-container">
          {files.map((file, index) => (
            <div key={index} className="file-preview-item">
              {file.type?.startsWith('image/') ? (
                <div className="file-preview-image">
                  <img 
                    src={localPreviewUrls[index] || URL.createObjectURL(file)} 
                    alt={`預覽 ${index}`} 
                  />
                </div>
              ) : (
                <div className="file-preview-doc">
                  <i className="file-icon"></i>
                </div>
              )}
              <div className="file-preview-name">{file.name}</div>
              <button 
                type="button" 
                className="file-delete-button"
                onClick={() => handleDelete(index)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FormFileUpload; 